import { render, staticRenderFns } from "./CommunicationTypeAdd.vue?vue&type=template&id=6777aafa&"
import script from "./CommunicationTypeAdd.vue?vue&type=script&lang=ts&"
export * from "./CommunicationTypeAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6777aafa')) {
      api.createRecord('6777aafa', component.options)
    } else {
      api.reload('6777aafa', component.options)
    }
    module.hot.accept("./CommunicationTypeAdd.vue?vue&type=template&id=6777aafa&", function () {
      api.rerender('6777aafa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/communicationTypes/CommunicationTypeAdd.vue"
export default component.exports